import React, { useEffect, useState } from 'react'
import { Table, Button, Modal, Form, Input, Select, Space, Popconfirm, message, Tag } from 'antd'
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import api from '../api'
import useStore from '../store'

export default function UsersPage() {
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false)
  const [editing, setEditing] = useState(null)
  const [form] = Form.useForm()
  const { user } = useStore()

  const load = () => api.get('/auth/users').then(setData)
  useEffect(() => { load() }, [])

  const openModal = (record = null) => {
    setEditing(record)
    form.setFieldsValue(record || { role: 'readonly' })
    setOpen(true)
  }

  const onSave = async () => {
    const values = await form.validateFields()
    try {
      if (editing) { await api.put(`/auth/users/${editing.id}`, values) }
      else { await api.post('/auth/users', values) }
      message.success('保存成功')
      setOpen(false)
      load()
    } catch (err) { message.error(err) }
  }

  const roleColors = { admin: 'red', finance: 'blue', readonly: 'default' }
  const roleLabels = { admin: '管理员', finance: '财务', readonly: '只读' }

  const columns = [
    { title: '姓名', dataIndex: 'name' },
    { title: '邮箱', dataIndex: 'email' },
    { title: '角色', dataIndex: 'role', render: v => <Tag color={roleColors[v]}>{roleLabels[v]}</Tag> },
    { title: '创建时间', dataIndex: 'created_at', render: v => new Date(v).toLocaleDateString() },
    {
      title: '操作', width: 100, render: (_, r) => (
        <Space>
          <Button size="small" icon={<EditOutlined />} onClick={() => openModal(r)} />
          {r.id !== user?.id && (
            <Popconfirm title="确认删除？" onConfirm={async () => { await api.delete(`/auth/users/${r.id}`); load() }}>
              <Button size="small" danger icon={<DeleteOutlined />} />
            </Popconfirm>
          )}
        </Space>
      )
    }
  ]

  return (
    <div>
      <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal()} style={{ marginBottom: 16 }}>新增用户</Button>
      <Table dataSource={data} columns={columns} rowKey="id" />
      <Modal title={editing ? '编辑用户' : '新增用户'} open={open} onOk={onSave} onCancel={() => setOpen(false)}>
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="姓名" rules={[{ required: true }]}><Input /></Form.Item>
          <Form.Item name="email" label="邮箱" rules={[{ required: true, type: 'email' }]}><Input /></Form.Item>
          <Form.Item name="password" label={editing ? '新密码(留空不修改)' : '密码'} rules={editing ? [] : [{ required: true }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item name="role" label="角色" rules={[{ required: true }]}>
            <Select>
              <Select.Option value="admin">管理员</Select.Option>
              <Select.Option value="finance">财务</Select.Option>
              <Select.Option value="readonly">只读</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
